import React from 'react'
import NavbarTop from '../NavbarTop'
import TeacherRegisterPage from '../registerpage/TeacherRegisterPage'
import Footer from '../Footer'

function TeacherRegister() {
  return (
    <div>
        <NavbarTop/>
        <TeacherRegisterPage/>
        <Footer/>
              {/* <NavbarTop/>
      <RegisterPage/>
      <Footer /> */}
    </div>
  )
}

export default TeacherRegister
